/**
 * @prettier
 * @flow
 */
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PhoneIcon from '@material-ui/icons/Phone';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from 'src/utils/translate/translate';

export function FormPhoneNumberField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    const maxLength = 20;

    return (
        <Controller
            as={TextField}
            name={`${name}.phoneNumber`}
            label={label}
            placeholder={translate('Phone Number')}
            // helperText={errors[name]?.['phoneNumber']?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('Phone number is required'),
                },
                maxLength: {
                    value: maxLength,
                    message: translate('Must be at most @number characters', { number: maxLength }),
                },
                pattern: {
                    value: /^[+()\[\]-\s0-9]+$/,
                    message: translate('Invalid phone number'),
                },
            }}
            error={!!errors[name]?.['phoneNumber']}
            InputProps={{
                ...InputProps,
                endAdornment: (
                    <InputAdornment position='end'>
                        <PhoneIcon color='action' />
                    </InputAdornment>
                ),
            }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            value={value}
            onChange={onChange}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderTopColor: 'white',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
            },
            '&:hover fieldset': {
                // borderBottomColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderBottomColor: 'white',
            },
        },
    },
}));

export type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
